import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { Box, Heading, FormControl, FormLabel, Input, Textarea, Button, VStack, Text } from '@chakra-ui/react';

const ContactPage = () => {
  const [state, handleSubmit] = useForm('mjkkzzbe'); // Replace 'mjkkzzbe' with your Formspree form ID.

  if (state.succeeded) {
    return (
      <Box textAlign="center" py={10} px={6} bg="pastelWhite">
        <Heading color="pastelGreen" mb={4}>Thank You!</Heading>
        <Text>Your message has been sent successfully. I'll get back to you soon.</Text>
      </Box>
    );
  }

  return (
    <Box py={10} px={6} bg="pastelWhite">
      <Heading textAlign="center" color="pastelBlue" mb={6}>
        Contact Me
      </Heading>
      <Box maxW="600px" mx="auto">
        <form onSubmit={handleSubmit}>
          <VStack spacing={4}>
            <FormControl id="email" isRequired>
              <FormLabel>Email Address</FormLabel>
              <Input
                id="email"
                type="email"
                name="email"
                placeholder="Your email address"
                focusBorderColor="pastelGreen"
              />
              <ValidationError prefix="Email" field="email" errors={state.errors} />
            </FormControl>
            <FormControl id="message" isRequired>
              <FormLabel>Message</FormLabel>
              <Textarea
                id="message"
                name="message"
                placeholder="Your message"
                focusBorderColor="pastelPink"
              />
              <ValidationError prefix="Message" field="message" errors={state.errors} />
            </FormControl>
            <Button
              type="submit"
              disabled={state.submitting}
              bg="pastelGreen"
              color="white"
              _hover={{ bg: 'pastelBlue' }}
            >
              Submit
            </Button>
          </VStack>
        </form>
      </Box>
    </Box>
  );
};

export default ContactPage;
